import { render, staticRenderFns } from "./LbSubscCustomerPortalLink.vue?vue&type=template&id=8fb07488&"
import script from "./LbSubscCustomerPortalLink.vue?vue&type=script&lang=js&"
export * from "./LbSubscCustomerPortalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports